import React from 'react';
import { FileCheck, CheckCircle2 } from 'lucide-react';
import { AdvantageCard } from '../components/AdvantageCard';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function AdvantagesPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20 min-h-screen bg-white" data-id="element-394">
      <SEOSchema type="about" title={t('Keunggulan & Legalitas | PT Graha Riau Gemilang', 'Advantages & Legal Compliance | PT Graha Riau Gemilang')} description={t('Keunggulan kompetitif dan legalitas lengkap PT Graha Riau Gemilang. Lokasi strategis, kualitas terjamin, dan dokumen resmi lengkap untuk ketenangan Anda.', 'Competitive advantages and complete legal compliance of PT Graha Riau Gemilang. Strategic locations, guaranteed quality, and complete official documentation for your peace of mind.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Keunggulan & Legalitas', 'Advantages & Legal Compliance'),
      url: 'https://grahariaugemilang.com/keunggulan-legalitas'
    }]} data-id="element-395" />

      <div className="bg-gray-50 py-16" data-id="element-396">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-397">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-398">
            {t('Keunggulan & Legalitas', 'Competitive Advantages & Legal Compliance')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-399">
            {t('Komitmen kami pada kualitas dan kepatuhan hukum untuk ketenangan Anda.', 'Our commitment to quality and legal compliance for your peace of mind.')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-400">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-401">
          {/* Competitive Advantages */}
          <div data-id="element-402">
            <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-403">
              {t('Keunggulan Kompetitif', 'Competitive Advantages')}
            </h2>
            <div className="grid grid-cols-1 gap-4" data-id="element-404">
              <AdvantageCard variant="list" title={t('Lokasi strategis dan mudah diakses', 'Strategically located developments')} description={t('Proyek kami selalu berada di lokasi dengan aksesibilitas tinggi dan dekat fasilitas umum.', 'Our projects are always in highly accessible locations near public facilities.')} data-id="element-405" />
              <AdvantageCard variant="list" title={t('Kualitas bangunan dengan material terbaik', 'High-quality construction and materials')} description={t('Kami tidak berkompromi soal kualitas. Material dipilih dengan standar ketat.', 'We never compromise on quality. Materials are selected with strict standards.')} data-id="element-406" />
              <AdvantageCard variant="list" title={t('Legalitas dan perizinan lengkap', 'Complete and transparent legal documentation')} description={t('Keamanan legalitas adalah prioritas utama kami demi ketenangan konsumen.', 'Legal security is our top priority for customer peace of mind.')} data-id="element-407" />
              <AdvantageCard variant="list" title={t('Desain modern dan fungsional', 'Modern and functional designs')} description={t('Arsitektur yang tidak hanya indah dipandang tapi juga nyaman ditinggali.', 'Architecture that is not only beautiful but also comfortable to live in.')} data-id="element-408" />
              <AdvantageCard variant="list" title={t('Harga kompetitif & bernilai investasi', 'Competitive pricing with strong investment value')} description={t('Menawarkan value for money terbaik dengan potensi kenaikan nilai aset.', 'Offering the best value for money with asset appreciation potential.')} data-id="element-409" />
              <AdvantageCard variant="list" title={t('Reputasi terpercaya lebih dari 20 tahun', 'Proven reputation for over 20 years')} description={t('Rekam jejak panjang membuktikan komitmen dan stabilitas perusahaan kami.', "A long track record proving our company's commitment and stability.")} data-id="element-410" />
            </div>
          </div>

          {/* Legality */}
          <div data-id="element-411">
            <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-412">
              {t('Legalitas Perusahaan', 'Legal Documentation')}
            </h2>
            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm" data-id="element-413">
              <div className="flex items-center mb-8" data-id="element-414">
                <div className="bg-green-100 p-3 rounded-full text-green-600 mr-4" data-id="element-415">
                  <FileCheck className="w-8 h-8" data-id="element-416" />
                </div>
                <div data-id="element-417">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-418">
                    {t('Dokumen Resmi', 'Official Documents')}
                  </h3>
                  <p className="text-gray-500" data-id="element-419">PT Graha Riau Gemilang</p>
                </div>
              </div>

              <ul className="space-y-6" data-id="element-420">
                <li className="flex items-start" data-id="element-421">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-422" />
                  <div data-id="element-423">
                    <span className="block font-medium text-gray-900" data-id="element-424">
                      {t('Akta Pendirian No. 97', 'Deed of Establishment No. 97')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-425">
                      {t('Notaris H. Asman Yunus, S.H.', 'Notary H. Asman Yunus, S.H.')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-426">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-427" />
                  <div data-id="element-428">
                    <span className="block font-medium text-gray-900" data-id="element-429">
                      {t('SK Menteri Kehakiman', 'Ministry of Justice Decree')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-430">
                      No. C-264 HT.03.01
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-431">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-432" />
                  <div data-id="element-433">
                    <span className="block font-medium text-gray-900" data-id="element-434">
                      {t('SIUP Menengah', 'Trading Business License (SIUP – Medium)')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-435">
                      {t('Izin Usaha Perdagangan', 'Business Trading Permit')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-436">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-437" />
                  <div data-id="element-438">
                    <span className="block font-medium text-gray-900" data-id="element-439">
                      TDP & NPWP
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-440">
                      {t('Terdaftar dan Patuh Pajak', 'Company Registration & Tax ID')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-441">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-442" />
                  <div data-id="element-443">
                    <span className="block font-medium text-gray-900" data-id="element-444">
                      {t('Anggota Real Estate Indonesia (REI)', 'Member of Real Estate Indonesia (REI)')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-445">No. 03.00174</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}